export default __webpack_public_path__ + "static/trash-panda-526a6370e9af4f8d0bebaff24c0b5f5e.svg";